import {ReactNode} from "react";
import {TooltipProps} from "@mui/material";
import {Box, Colors, IconInfo} from "@bounce/shared/ui";
import {Tooltip} from "../../ui/components";

type InfoTooltipProps = {
  content: ReactNode;
  placement?: TooltipProps["placement"];
  size?: number;
  color?: string;
};

export const InfoTooltip = ({content, placement, size = 16, color = Colors.grey._500}: InfoTooltipProps) => (
  <Tooltip title={content} placement={placement}>
    <Box component="span" sx={{display: "inline-flex", cursor: "help", color}}>
      <IconInfo color={color} style={{width: size, height: size}} />
    </Box>
  </Tooltip>
);
